import React from 'react';

function Navbar(){

    return (
        <div>
            <nav>
                <header>
                    <h1 className="navbar-header">
                        Giphy Generator
                    </h1>
                </header>
            </nav>
        </div>
    )

}

export default Navbar;